import { useFormat } from 'helpers/hooks/useFormat';

const PaymentFailedAlert: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="mb-8 border-l-4 border-red-500 bg-red-100 p-4 text-red-700" role="alert">
      <p>
        {formatMessage({
          id: 'error.paymentFailed',
          defaultMessage: 'Si è verificato un errore durante il pagamento, per favore riprova.',
        })}
      </p>
    </div>
  );
};

export default PaymentFailedAlert;
